module.exports = __webpack_public_path__ + "static/media/sound2.b43898f1.mp3";